import { useState } from "react";
import { CardHistoricoProps } from "./Base/types";
import { IItemHistoricoPlano, IItemHistoricoServico } from "../../types";
import { getCardForItem } from "./CardRegistry";
import { FallbackCard, FallbackCardTitle, FallbackCardSubtitle } from "./styles";

interface CardHistoricoWrapperProps {
  item: IItemHistoricoPlano | IItemHistoricoServico;
}

export default function CardHistorico({ item }: CardHistoricoWrapperProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const config = getCardForItem(item);
  
  if (!config) {
    return (
      <FallbackCard>
        <FallbackCardTitle>{item.acao}</FallbackCardTitle>
        <FallbackCardSubtitle>
          {item.nome_responsavel} • {item.tipo_responsavel}
        </FallbackCardSubtitle>
      </FallbackCard>
    );
  }

  const Component = config.Component;

  return (
    <Component
      item={item}
      isExpanded={isExpanded}
      onToggleExpand={() => setIsExpanded(!isExpanded)}
    />
  );
}
